module.exports = __webpack_public_path__ + "854ea5059d414272448597fb3e056422.svg";